import React from 'react';
import { FormField } from 'taboola-ultimate-ui';
import { OutlineEditableText } from 'modules/campaigns/components/OutlineEditableText/OutlineEditableText';
import { withIndication } from 'modules/errors';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { useFormValidatedValue, validationFunctions } from 'modules/taboola-common-frontend-modules/validations';
import styles from './subscriptionUserIdField.module.scss';

const OutlineEditableTextWithIndication = withIndication(OutlineEditableText);
const validations = [
    {
        validationFn: validationFunctions.isNotEmpty,
        messageId: 'push-api.subscription.validations.error.userId.empty',
        defaultMessage: 'Please enter a User ID',
    },
    {
        validationFn: validationFunctions.isNumeric,
        messageId: 'push-api.subscription.validations.error.userId.number',
        defaultMessage: 'User ID must be a number',
    },
];

export const SubscriptionUserIdField = () => {
    const {
        value: userId,
        onChange: onUserIdChange,
        indicationData,
    } = useFormValidatedValue({
        field: 'userId',
        validations,
    });

    const { formatMessage } = useIntl();
    const placeholder = formatMessage({
        id: `push-api.subscription.userId.placeholder`,
        defaultMessage: 'Type user id here...',
    });

    return (
        <FormField
            inputId="subscription-userId-input"
            containerClass={styles['input-container']}
            label={<FormattedMessage id="push-api.subscription.userId.title" defaultMessage="User ID" />}
        >
            <OutlineEditableTextWithIndication
                id="userId"
                value={userId}
                onChange={onUserIdChange}
                placeholder={placeholder}
                {...indicationData}
            />
        </FormField>
    );
};
